export default __webpack_public_path__ + "static/SFMono-MediumItalic-fc55a344c2a9f1128724860d82a3322b.ttf";